export default __webpack_public_path__ + "static/media/nepal_sac.3ff645a8.jpg";